/**
 * Force-download PDFs from Shopify CDN — HTML `download` is ignored cross-origin.
 * Binds any `.wd-ai__download--force` link (assembly instructions + product technical info).
 */
(function () {
  const SELECTOR = '.wd-ai__download--force';

  function filenameFromUrl(url) {
    try {
      var name = new URL(url, window.location.href).pathname.split('/').pop() || '';
      name = name.split('?')[0];
      if (name && /\.pdf$/i.test(name)) return name;
    } catch (e) {
      /* ignore */
    }
    return 'download.pdf';
  }

  function resolveFilename(link, url) {
    var attr = (link.getAttribute('download') || link.dataset.wdPdfFilename || '').trim();
    if (attr && attr !== 'download') return attr;
    return filenameFromUrl(url);
  }

  function saveBlob(blob, filename) {
    var blobUrl = URL.createObjectURL(blob);
    var anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.download = filename || 'download.pdf';
    anchor.rel = 'noopener';
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(function () {
      URL.revokeObjectURL(blobUrl);
    }, 1000);
  }

  async function onDownloadClick(event) {
    event.preventDefault();
    var link = event.currentTarget;
    var url = (link.getAttribute('href') || '').trim();
    if (!url || link.classList.contains('is-downloading')) return;

    var filename = resolveFilename(link, url);

    link.classList.add('is-downloading');
    link.setAttribute('aria-busy', 'true');

    try {
      var response = await fetch(url, { mode: 'cors', credentials: 'omit', cache: 'no-cache' });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      saveBlob(await response.blob(), filename);
    } catch (err) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } finally {
      link.classList.remove('is-downloading');
      link.removeAttribute('aria-busy');
    }
  }

  function bind(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(SELECTOR).forEach(function (link) {
      if (link.dataset.wdPdfBound === '1') return;
      link.dataset.wdPdfBound = '1';
      link.addEventListener('click', onDownloadClick);
    });
  }

  function boot() {
    bind(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target || document);
  });
})();
